import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}
    :host {
        font-family: var(--sgdf-font-sans);
    }

    .team-item {
        padding-bottom: var(--sgdf-spacing-x-small);
    }

    .team-form {
        border-radius: var(--sgdf-border-radius-large);
        background-color: var(--sgdf-color-background);
        border-left: var(--sgdf-spacing-x-small) solid;
    }

    .team-peview {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: var(--sgdf-border-radius-large);
        padding: var(--sgdf-spacing-x-small) var(--sgdf-spacing-small);
        color: white;
        font-weight: bold;
    }

    .team-peview.open {
        border-radius: var(--sgdf-border-radius-large)
            var(--sgdf-border-radius-large) 0 0;
    }

    .left,
    .right {
        display: flex;
        align-items: center;
    }

    .participant-list-container {
        padding: 0 0;
        border: 1px solid var(--team-color);
        border-radius: 0 0 var(--sgdf-border-radius-large)
            var(--sgdf-border-radius-large);
        box-sizing: border-box;
    }
`;
//# sourceMappingURL=team-item.styles.js.map